<template>
  <component
    :is="type"
    :to="to"
    :disabled="disabled"
    class="button"
    :class="{ arrowleft: arrow === 'left', arrowright: arrow === 'right' }"
    @click="$emit('click')"
  >
    <template v-if="arrow === 'left'">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.5 8H0.5"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.5 15L0.5 8L7.5 1"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </template>
    <span v-if="$slots.default"><slot /></span>
    <template v-if="arrow === 'right'">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.5 8H15.5"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.5 15L15.5 8L8.5 1"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </template>
    <span v-if="x" class="x">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 14L14 2"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14 14L2 2"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
  </component>
</template>

<script>
export default {
  name: "Button",
  props: {
    x: {
      type: String,
      default: ""
    },
    arrow: {
      type: String,
      default: ""
    },
    to: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    type() {
      if (this.to) {
        return "router-link";
      }
      return "button";
    }
  }
};
</script>

<style lang="scss">
.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  border: 0;
  padding: 16px 20px;
  transition: all 0.3s ease-in-out;
  text-decoration: none;
  max-height: 50px;
  // box-sizing: content-box;
  box-sizing: border-box;
  cursor: pointer;
  span {
    font-family: $main;
    font-size: 16px;
    line-height: 18px;
    font-weight: 500;
    display: block;
    // margin-top: 3px;
  }
  svg {
    display: block;
  }
  span.x {
    background: $black;
    color: $white;
    border-radius: 50%;
    display: flex;
    width: 32px;
    height: 32px;
    justify-content: center;
    align-items: center;
    margin-left: 12px;
    svg {
      width: 16px;
      height: 16px;
    }
  }
  &.fullwidth {
    width: 100%;
  }
  &.icoonly {
    padding: 16px;
  }
  &.circle {
    padding: 16px;
    border-radius: 50%;
  }
  &.arrowright {
    span {
      margin-right: 8px;
    }
  }
  &.arrowleft {
    span {
      margin-left: 8px;
    }
  }
  &.blue {
    background: $blue;
    color: $white;
    /* background: $black;
    &:hover {
      background: $black;
    } */
  }
  &.white {
    background: $white;
    color: $black;
  }
  &.superwhite {
    background: white;
    color: #525252;
  }
  &.black {
    background: $black;
    color: $white;
    /* &:hover {
      background: $black;
    } */
  }

  &[disabled],
  &.disabled {
    background: #ccc;
    color: #7c7c7c;
    pointer-events: none;
  }
}

@media screen and (min-width: $breakpoint) {
  .button {
    &.blue {
      //background: $blue;
      &:hover {
        background: $blueHover;
      }
    }
    &.black {
      &:hover {
        background: $blackHover;
      }
    }
    &.superwhite {
      &:hover {
        color: white;
        background: $blackHover;
      }
    }
  }
}
</style>
